import React from 'react';
import { Lightbulb, X } from 'lucide-react';

const DailyPrompt = ({ prompt, onDismiss, onCapture }) => {
  return (
    <div className="mb-8 bg-gradient-to-br from-[#FFD60A] via-[#FFE44D] to-[#FFEB80] border-2 border-[var(--border-default)] p-6 relative daily-prompt-enter overflow-hidden" data-testid="daily-prompt">
      <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-[#0A0A0A] opacity-20"></div>
      <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-[#0A0A0A] opacity-20"></div>
      
      <div className="flex items-start justify-between gap-4 relative z-10">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="p-2 bg-[#0A0A0A] border border-[#0A0A0A]">
              <Lightbulb size={18} className="text-[#FFD60A]" />
            </div>
            <h3 className="text-xs font-mono uppercase tracking-[0.2em] text-[#0A0A0A] font-bold">Daily Spark</h3>
          </div>
          <p className="text-base sm:text-lg font-semibold text-[#0A0A0A] mb-4 leading-relaxed">
            {prompt}
          </p>
          <button
            data-testid="prompt-new-idea-btn"
            onClick={onCapture}
            className="bg-[#0A0A0A] text-[#FFD60A] font-bold px-5 py-2.5 text-sm border-2 border-[#0A0A0A] hover:translate-x-[2px] hover:translate-y-[2px] transition-transform duration-150"
          >
            Capture This Idea &rarr;
          </button>
        </div>
        <button
          data-testid="dismiss-prompt-btn"
          onClick={onDismiss}
          className="text-[#0A0A0A] hover:bg-[#0A0A0A]/10 p-2 transition-all duration-150 border border-transparent hover:border-[#0A0A0A]/20"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default DailyPrompt;
